const appraiserAssignmentApproval = {
  getAssignmentApproval(controlIdNumber) {
    return `/assignment/appraisal/${controlIdNumber}/approval/current`;
  },
  setAssignmentApproval(controlIdNumber) {
    return `/assignment/appraisal/${controlIdNumber}/approval`;
  },  
};

export default appraiserAssignmentApproval;